import React, { Component } from 'react';
import { Field, change, reduxForm, reset} from 'redux-form';
import { renderAutoCompleteSingleSelect, renderTextField, isInteger, isFloat,normalizeDecimal,} from '../../../../../../../../components/reduxFields';
import { selectedProgramForPatientSkillAcqDomains,selectedProgramForPatientSkillAcqProgram, selectedProgramForPatientSkillAcqTarget, get_patientSkillAcqCollectDataNewFlow, EnableTodayLabel, DesableTodayLabel, ResetList} from "./actions/targetsActionNewFlow";
import { updateSkillAcqCollectedTADataPromtCodeAction, updateSkillAcqCollectedDTTDataPromtCodeAction, updateCollectedSkillAquisitionBehaviorDataForTodaysData,deleteSkillAquisitionBehaviorCollactDataForTodaysData} from '../../../../../DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions';
import Sorting from '../../../../../../../../components/SortingCustom';
import PaginatorCustom from '../../../../../../../../components/paginationCustom';
import { connect } from 'react-redux';
import moment from 'moment';
import { getMasterData } from './actions/targetsActionNewFlow';
import classNames from 'classnames';
import { setCollapseMenuId } from './actions/targetsActionNewFlow';
import { setIsEventOccureSABCollactDataListByTargetIdFalse } from '../../../../../DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions';
import { setIsEventOccurePatientSkillAcqCollectDataNewFlowFalse } from './actions/targetsActionNewFlow'; 
import { setIsEventOccureSkillAcqFalse } from '../../../../../DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions';
import { showFormatedDateandTime } from '../../../../../../../../actions/utilAction';
import { confirmAlert } from 'react-confirm-alert';
import { deletePatientSkillAcqCollectedData } from './actions/targetsActionNewFlow';
import { RaisedButton } from 'material-ui';
import CollectDTTData from './CollectDTTData';
import CollectTAData from './CollectTAData';

const collectDataScreenName = "COLLECTDATA";

class TodaysData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientId : props.patientId,
            domainId:props.domainId,
            sessionId:props.uuid,
            sessionDate:props.creadteDate,
            includeMasteredTargetsOnly : true,
            selectedDomain: null,
            selectedProgram: null,
            selectedTarget: null,
            selectedType: null,
            openTodaysDataModal: false,
            skillsAcquisitionTargetId:null,
            skillsAcquisitionProgramId:null,
            targetId: null,
            type: null,
            deleteModal: false,
            collectedDataId: null,
            frequencyValue: 0,
            selectedRecordDataIds: [],
                                }

          this.timeout = null;
          this.timeout2 = null;
          this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };  

        this.handleDomainNameSelection = this.handleDomainNameSelection.bind(this);
        this.handleProgramNameSelection = this.handleProgramNameSelection.bind(this);
        this.handleTargetNameSelection = this.handleTargetNameSelection.bind(this);
        this.handleTargetTypeSelection = this.handleTargetTypeSelection.bind(this);
        this.handleFilter = this.handleFilter.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
    }
    
    loadData() {                       
        this.props.selectedProgramForPatientSkillAcqDomains(this.state.patientId);                
        this.props.selectedProgramForPatientSkillAcqProgram(this.state.patientId,0);
        this.props.selectedProgramForPatientSkillAcqTarget(this.state.patientId,0,0);
    }

    componentWillMount() {     
        this.props.EnableTodayLabel();                  
        this.loadData();
        let masterData = { 'masterdata': 'MASTERTARGETTYPE'};   
        this.props.getMasterData(masterData);
        this.handleFilter();
    }

    componentWillUnmount() {
      this.props.DesableTodayLabel();
    }

    componentWillReceiveProps(nextProps) {
      let self = this;
      document.onkeydown = function (evt) {
          evt = evt || window.event;
          if (evt.keyCode === 27) {
              self.handleClose();
          }
      };
      if (nextProps.patientSkillAcqCollectedDataList && nextProps.patientSkillAcqCollectedDataList.patSkillsAcqTaskAnalysisCollectedData)
      {
       (nextProps.patientSkillAcqCollectedDataList.patSkillsAcqTaskAnalysisCollectedData || []).forEach((obj, index) => 
          {
          this.props.dispatch(change('TodaysDataForm', `Target[${obj.promptCodeName}].promptCodeInner`, obj.promptCodeId || null
           || null));
          });
      }
      if (nextProps.patientSkillAcqCollectedDataList && nextProps.patientSkillAcqCollectedDataList.patientSkillsAcqCollectedData)
      {
          (nextProps.patientSkillAcqCollectedDataList.patientSkillsAcqCollectedData || []).forEach((obj, index) => 
          {
           this.props.dispatch(change('TodaysDataForm', `Target[${index}].promptCode`, obj.promptCodeId
           || null));
          });
      }
      if (nextProps.patientSkillAcqCollectedDataList && nextProps.patientSkillAcqCollectedDataList.patientSkillsAcqCollectedData)
      {
          (nextProps.patientSkillAcqCollectedDataList.patientSkillsAcqCollectedData || []).forEach((obj, index) => 
          {
           this.props.dispatch(change('TodaysDataForm', `Target[${index}].value`, obj.value
           || null));
          });
      }
      if (nextProps.patientSkillAcqCollectedDataList && nextProps.patientSkillAcqCollectedDataList.patientSkillsAcqCollectedData)
      {
          (nextProps.patientSkillAcqCollectedDataList.patientSkillsAcqCollectedData || []).forEach((obj, index) => 
          {
           this.props.dispatch(change('TodaysDataForm', `Target[${index}].duration`, obj.duration
           || null));
          });
      }
    }
    
    handleDomainNameSelection(input, selected) {
      input.onChange(selected.value);
      //this.setState({selectedDomain: selected});
      this.setState({selectedDomain: selected}, () => {
            this.props.selectedProgramForPatientSkillAcqProgram(this.state.patientId, selected.value);
            this.props.selectedProgramForPatientSkillAcqTarget(this.state.patientId, selected.value, 0);
        });
    }
           
    handleProgramNameSelection(input, selected) {
      input.onChange(selected.value);
      this.setState({selectedProgram: selected}, () => {
          this.props.selectedProgramForPatientSkillAcqTarget(this.state.patientId, 0, selected.value);
          if(selected.value.length < 1){
            this.setState({selectedTarget: null});
          }
        });
      //this.setState({selectedProgram: selected});
    }

    handleTargetNameSelection(input, selected) {
      input.onChange(selected.value);
     this.setState({selectedTarget: selected});
    }
    
    handleTargetTypeSelection(input, selected){
      input.onChange(selected.value);
      this.setState({selectedType:selected.label});
    }

    handleReset = () => {
     this.props.dispatch(reset('TodaysDataForm'));
      this.setState({
          selectedActiveProgramIds: this.props.ProgramIds,
          includeMasteredTargetsOnly : true,
          selectedDomain: null,
          selectedProgram: null,
          selectedTarget: null,
          selectedType: null,
          openTodaysDataModal: false,
        }, () => {     
          // this.props.dispatch(change("TodaysDataForm", "programName", null));
          // this.props.dispatch(change("TodaysDataForm", "targetName", null));
           this.props.dispatch(change("TodaysDataForm", "targetType", null));
           this.handleFilter();
          this.loadData();
      });
    }

    handleFilter(page_number){
      let searchObj = {
        sort_fields: this.filter.sort_Column || '',
        sort_order: this.filter.sort_order || '',
        contain_filters: { searchText: this.filter.searchText || null },
        pageNumber:  page_number || 1,
     };
      
      this.props.get_patientSkillAcqCollectDataNewFlow(
      {
      searchObj:searchObj,
      patientId:  this.state.patientId,
      domainId:this.state.selectedDomain && this.state.selectedDomain.value || 0,
      sessionId: this.state.sessionId,
      sessionDate: this.state.sessionDate,
      targetId: this.state.selectedTarget && this.state.selectedTarget.value || 0,      
      targetType: this.state.selectedType ? this.state.selectedType : '',
      programId: this.state.selectedProgram && this.state.selectedProgram.value || 0,
      includeMasteredTargetsOnly: this.state.includeMasteredTargetsOnly}
      )
    }

    setSortColumn(col_name, col_order) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.handleFilter();
    }

    handleEditClick = (data) => {
      
      // console.log(data, "DATATAAT")
      
      if(data.targetType === "Task Analysis"){
        this.setState({ openNewProgram: true ,type:'TASK ANALYSIS' , collectedDataId :data.id, targetType:data.targetType })
      }else if(data.targetType === "DTT"){
        this.setState({ openNewProgram: true,type:'DTT', collectedDataId:data.id,targetType:data.targetType })
      }
    }

    handleDeleteClick = (e, data) => {
      this.setState({
          deleteModal : true
      })
      confirmAlert({
          title: 'Delete Selected Trial',
          message: 'Are you sure you want to delete this trial?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                  this.props.deletePatientSkillAcqCollectedData(this.state.patientId, this.props.uuid, this.props.creadteDate,data.id, data.skillsAcquisitionTargetId, "DTT")
                  this.setState({
                      deleteModal: false
                  })
                  setTimeout(function() {
                    this.handleFilter()
                  }.bind(this),1000)
              }

            },
            {
              label: 'No',
              onClick: () => {
                  this.setState({
                      deleteModal: false
                  })
              }
            }
          ],
          closeOnClickOutside: false, //By Default it is true
          closeOnEscape: false,       //By Default it is true
        });
    }
    handleDeleteBehavior = (e, data) => {
      this.setState({
        selectedRecordDataIds: []
      })
      confirmAlert({
          title: 'Delete Selected Trial',
          message: 'Are you sure you want to delete this trial?',
          buttons: [
            {
              label: 'Yes',
              onClick: () => {
                  let searchObj = {
                    sort_fields: this.filter.sort_Column || '',
                    sort_order: this.filter.sort_order || '',
                    contain_filters: { searchText: this.filter.searchText || null },
                    pageNumber:  1,
                  };
                  
                let dataForFilter = {       
                  patientId:  this.state.patientId,
                  domainId:this.state.selectedDomain && this.state.selectedDomain.value || 0,
                  sessionId: this.state.sessionId,
                  sessionDate: this.state.sessionDate,
                  targetId: this.state.selectedTarget && this.state.selectedTarget.value || 0,      
                  targetType: this.state.selectedType ? this.state.selectedType : '',
                  programId: this.state.selectedProgram && this.state.selectedProgram.value || 0,
                  includeMasteredTargetsOnly: this.state.includeMasteredTargetsOnly
                  }
                this.props.deleteSkillAquisitionBehaviorCollactDataForTodaysData(data.recordSkAcqDataDetailId, data.targetType, data.patientId, data.skillsAcquisitionProgramId, data.skillsAcquisitionTargetId,data.duration, searchObj, dataForFilter,collectDataScreenName.toUpperCase())
                  this.setState({
                    deleteModal: false
                  })
                  // setTimeout(function() {
                  //   this.handleFilter()
                  // }.bind(this),1000)
              }

            },
            {
              label: 'No',
              onClick: () => {
                  this.setState({
                      deleteModal: false
                  })
              }
            }
          ],
          closeOnClickOutside: false, //By Default it is true
          closeOnEscape: false,       //By Default it is true
        });
    }
    
    

    handleClose = () => {
      this.setState({openNewProgram : false })
    };

    handleExpandRow = (Id) => {
      // console.log("handleExpandRow",this);
      // console.log("handleExpandRow Id-->",Id);
      this.setState({ Id: Id });
      this.props.setCollapseMenuId(Id);
      let display = this.refs['expandedClass' + Id].style.display;
      if (display === 'none') {
        this.refs['expandedClass' + Id].style.display = 'table-row';
        this.refs['expClass' + Id].className = 'classExpand fa fa-minus';
      } else {
        this.refs['expandedClass' + Id].style.display = 'none';
        this.refs['expClass' + Id].className = 'classExpand fa fa-ellipsis-h';
      }
  }


  onRerenderListMakeCollapseOpen(Id){
    if(Id){
      // console.log("onRerenderListMakeCollapseOpen", 'expandedClass-' + Id);
      let element = document.getElementById('expandedClass-' + Id);
      let element2 = document.getElementById('expClass-' + Id);
      // console.dir(element);
      let display = element.style.display;
      // console.log("display",display);
      if (display === 'none') {
        // console.log("display none true");
        element.style.display = 'table-row';
        element2.className = 'classExpand fa fa-minus';
        // console.dir(element);
      }
    }
  }



  componentDidUpdate(prevProp){
    const collapseMenuId = this.props.collapseMenuId;
    // console.log("collapseMenuId",collapseMenuId);
    
    if(prevProp.isEventOccureSkillAcq !== this.props.isEventOccureSkillAcq ){
      if(this.props.isEventOccureSkillAcq){        
        this.handleFilter();
        this.props.setIsEventOccureSkillAcqFalse();
      }
    }

    if(prevProp.isEventOccurePatientSkillAcqCollectDataNewFlow !== this.props.isEventOccurePatientSkillAcqCollectDataNewFlow){
      // console.log("call inside second if");
      // console.log("collapseMenuId",collapseMenuId);
      if(this.props.isEventOccurePatientSkillAcqCollectDataNewFlow){
        this.onRerenderListMakeCollapseOpen(collapseMenuId);
        this.props.setIsEventOccurePatientSkillAcqCollectDataNewFlowFalse();
      }
    }
    if(prevProp.isEventOccureSABCollactDataListByTargetId !== this.props.isEventOccureSABCollactDataListByTargetId){
      // console.log("call inside second if");
      // console.log("collapseMenuId",collapseMenuId);
      if(this.props.isEventOccureSABCollactDataListByTargetId){
        this.handleFilter();
        this.props.setIsEventOccureSABCollactDataListByTargetIdFalse();
      }
    }
   }

  handleNewRequestPromptCodeTA = (input, selectedRecord, targetId) => {
    input.onChange(selectedRecord.value);
    this.props.updateSkillAcqCollectedTADataPromtCodeAction(targetId, selectedRecord.value, this.state.patientId, this.state.targetId)
  };

  handleNewRequestPromptCodeDTT = (input, selectedRecord, targetId) => {
    input.onChange(selectedRecord.value);
    this.props.updateSkillAcqCollectedDTTDataPromtCodeAction(targetId, selectedRecord.value, this.state.patientId, this.state.targetId)
  };

  handleValueChange = (event, data, action) => {

    clearTimeout(this.timeout2);


   let frequencyValue = event.target.value;
      const hasSpecialCharacters = /[!@#$%^&*(),.?":{}|<>]/.test(frequencyValue);
    if (!hasSpecialCharacters) {
      let searchObj = {
        sort_fields: this.filter.sort_Column || '',
        sort_order: this.filter.sort_order || '',
        contain_filters: { searchText: this.filter.searchText || null },
        pageNumber:  1,
      };
      
     let dataForFilter = {       
      patientId:  this.state.patientId,
      domainId:this.state.selectedDomain && this.state.selectedDomain.value || 0,
      sessionId: this.state.sessionId,
      sessionDate: this.state.sessionDate,
      targetId: this.state.selectedTarget && this.state.selectedTarget.value || 0,      
      targetType: this.state.selectedType ? this.state.selectedType : '',
      programId: this.state.selectedProgram && this.state.selectedProgram.value || 0,
      includeMasteredTargetsOnly: this.state.includeMasteredTargetsOnly
      }
            
      this.timeout2 = setTimeout(() => {
        this.props.updateCollectedSkillAquisitionBehaviorDataForTodaysData(data.id, data.recordSkAcqDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, frequencyValue, 0.0, data.patientId, action, data.targetType.toUpperCase(), searchObj, dataForFilter,collectDataScreenName.toUpperCase()) 
      }, 3000);

      // this.props.updateCollectedSkillAquisitionBehaviorDataForTodaysData(data.id, data.recordSkAcqDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, frequencyValue, 0.0, data.patientId, action, data.targetType.toUpperCase(), searchObj, dataForFilter)            
      //this.handleFilter();
    
    }
    
  }

  handleDurationChange = (event, data, action) => {

    clearTimeout(this.timeout);

    let durationValue = event.target.value;
        const hasSpecialCharacters = /[!@#$%^&*(),?":{}|<>]/.test(durationValue);
       if (!hasSpecialCharacters) {
        let searchObj = {
          sort_fields: this.filter.sort_Column || '',
          sort_order: this.filter.sort_order || '',
          contain_filters: { searchText: this.filter.searchText || null },
          pageNumber:  1,
        };
        
       let dataForFilter = {       
        patientId:  this.state.patientId,
        domainId:this.state.selectedDomain && this.state.selectedDomain.value || 0,
        sessionId: this.state.sessionId,
        sessionDate: this.state.sessionDate,
        targetId: this.state.selectedTarget && this.state.selectedTarget.value || 0,      
        targetType: this.state.selectedType ? this.state.selectedType : '',
        programId: this.state.selectedProgram && this.state.selectedProgram.value || 0,
        includeMasteredTargetsOnly: this.state.includeMasteredTargetsOnly
        }

        this.timeout = setTimeout(() => {
          this.props.updateCollectedSkillAquisitionBehaviorDataForTodaysData(data.id, data.recordSkAcqDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, 0, durationValue, data.patientId, action, data.targetType.toUpperCase(), searchObj, dataForFilter,collectDataScreenName.toUpperCase());
        }, 3000);
      // this.props.updateCollectedSkillAquisitionBehaviorDataForTodaysData(data.id, data.recordSkAcqDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, 0, durationValue, data.patientId, action, data.targetType.toUpperCase(), searchObj, dataForFilter);
     
    }
   
  }


    renderInnerData(collectedDataId) {
      const { patientSkillAcqCollectedDataList } = this.props;        
      let TaskAnalysisInnerData = (patientSkillAcqCollectedDataList && patientSkillAcqCollectedDataList.patSkillsAcqTaskAnalysisCollectedData) || [];
      let filteredTaskAnalysisData = TaskAnalysisInnerData.filter((obj) => obj.collectedDataId === collectedDataId);

      

      if (!filteredTaskAnalysisData.length) {
        return <tr><td colSpan="7" className="text-center no-record">No record found.</td></tr>;
      }
      return filteredTaskAnalysisData.map((data, index) => {
        return (
          <tr key={index}>
            <td width="5%"></td>
            <td width="35%">{data.taskName}</td>              
            <td width="35%">
              <Field
                name={`Target[${data.promptCodeName}].promptCodeInner`}  
                hintText="Prompt Code"
                handleNewRequest={(input, selectedValue) => this.handleNewRequestPromptCodeTA(input, selectedValue, data.id)}
                options={this.props.promptCodeListData.data.filter((op) => op.ta === true)}
                disabled={this.props.updatePermissionSkillAquisition ? false : true}
                component={renderAutoCompleteSingleSelect}
              />
            </td>
            <td width="25%">{data.abbreviation}</td>
          </tr>
        );
      });
    }

      

    renderData(patientSkillsAcqCollectedDataList) {
      patientSkillsAcqCollectedDataList = patientSkillsAcqCollectedDataList || [];
        if (!patientSkillsAcqCollectedDataList.length) {
            return (
                <tr>
                    <td colSpan="8">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
      return patientSkillsAcqCollectedDataList.map((data, index) => {
        // console.log("data........",data)

        const tableClass = classNames({
          'table': true,
          'tableAuditLog': true,
          'table-striped': this.props.condensed,
          'table-bordered': this.props.bordered,
          'table-hover': true,
          'table-condensed': this.props.condensed,
          'customtable': true,
        });


        const tableClass2 = classNames({
          'table': true,
          'childtable': true,
        });  
    
        if(data.targetType === "DTT"){
          return (
            <tr key={index}>
                <td td width="5%"></td>
                <td width="15%">{data.domainName}</td>
                <td width="12%">{data.programName}</td>
                <td width="10%">{data.targetName}</td>
                <td width="12%">{data.targetType}</td>
                <td width="21%">
                    <Field
                    name={`Target[${index}].promptCode`}
                    hintText="Prompt Code"
                    handleNewRequest={(input, selectedValue) => this.handleNewRequestPromptCodeDTT(input, selectedValue, data.id)}
                    options={this.props.promptCodeListData.data.filter((op) => op.dtt === true)}
                    disabled={this.props.updatePermissionSkillAquisition ? false : true}
                    component={renderAutoCompleteSingleSelect}
                    />
                </td>
                <td width="20%">{showFormatedDateandTime(data.sessionDate)}</td> 
                <td width="5%">
                  {/* <button onClick={(e) => this.handleEditClick(data)}  type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button> */}
                  {this.props.deletePermissionSkillAquisition && <button onClick={(e) => this.handleDeleteClick(e, data)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>}
                </td>
            </tr>
          );
        }else if(data.targetType === "Task Analysis"){
          return (
            <tr key={index}>
              <td colSpan="8">
                <table className={tableClass}>
                  <tbody>
                    <tr>
                      <td width="5%">
                        <button onClick={(e) => this.handleExpandRow(data.id)} type="button" className="morebtn">
                        <i ref={'expClass' + data.id} id={'expClass-' + data.id} className="fa fa-ellipsis-h" aria-hidden="true"></i>
                        </button>
                      </td>
                      <td width="15%">{data.domainName}</td>
                      <td  width="12%">{data.programName}</td>
                      <td  width="10%">{data.targetName}</td>
                      <td  width="12%">{data.targetType}</td>
                      <td width="21%">{data.abbreviation}</td>
                      <td  width="20%">{showFormatedDateandTime(data.sessionDate)}</td> 
                      <td width="5%">
                        {/* <button onClick={(e) => this.handleEditClick(data)}  type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button> */}
                        {this.props.deletePermissionSkillAquisition && <button onClick={(e) => this.handleDeleteClick(e, data)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>}
                      </td>
                    </tr>
                    <tr className="nohover" ref={'expandedClass' + data.id} id={'expandedClass-' + data.id} style={{ 'display': 'none' }}>
                      <td colSpan="7">
                        <table className={tableClass2}>
                          <thead>
                            <tr>
                              <th width="5%"></th>
                              <th width="35%">Step Name</th>                                
                              <th width="35%">Prompt Code</th>
                              <th width="25%">Abbreviation</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.renderInnerData(data.id)}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          );
        }else if(data.targetType === "Frequency"){
          return (
            <tr key={index}>
                <td td width="5%"></td>
                <td width="20%">{data.domainName}</td>
                <td width="12%">{data.programName}</td>
                <td width="10%">{data.targetName}</td>
                <td width="12%">{data.targetType}</td>
                <td width="12%">
                <Field
                  name={`Target[${index}].value`}
                  type="text"
                  maxLength="2"
                  component={renderTextField}
                  normalize={isInteger}
                  disabled={this.props.updatePermissionSkillAquisition ? false : true}
                  onInput={(event) => this.handleValueChange(event, data, 'VALUE')}
                />
              </td>
                <td width="20%">{showFormatedDateandTime(data.sessionDate)}</td> 
                <td width="9%">
                {this.props.deletePermissionSkillAquisition && <button onClick={(e) => this.handleDeleteBehavior(e, data)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>}
                </td>
            </tr>
          );
        }
        else{
          return (
            <tr key={index}>
                <td td width="5%"></td>
                <td width="20%">{data.domainName}</td>
                <td width="12%">{data.programName}</td>
                <td width="10%">{data.targetName}</td>
                <td width="12%">{data.targetType}</td>
                <td width="12%">
                <Field
                  name={`Target[${index}].duration`}
                  type="text"
                  maxLength="8"
                  component={renderTextField}
                  normalize={isFloat}
                  disabled={this.props.updatePermissionSkillAquisition ? false : true}
                  onInput={(event) => this.handleDurationChange(event, data, 'DURATION')}
                />
                  <small>(Ex: 15 sec = 0.25 min)</small>
                </td>
                <td width="20%">{showFormatedDateandTime(data.sessionDate)}</td> 
                <td width="9%">
                {this.props.deletePermissionSkillAquisition && <button onClick={(e) => this.handleDeleteBehavior(e, data)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>}
                </td>
            </tr>
             
          );
        }
      });
    }
      
      render() {
        const { handleSubmit, patientSkillAcqCollectedDataList, patientSkillAcqCollectedMeta } = this.props;     
        // console.log("patientSkillAcqCollectedDataList",patientSkillAcqCollectedDataList)   
        let patientSkillsAcqCollectedDataList = (patientSkillAcqCollectedDataList && patientSkillAcqCollectedDataList.patientSkillsAcqCollectedData) || [];
        let PatientSkillAcqCollectedMeta = patientSkillAcqCollectedMeta  || [];
        const tableClass = classNames({
            'table': true,
            'tableAuditLog': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
          });

          // console.log(this.state, "STATATATATAATATATATA")
          // console.log(this.props, "props")

        return(
            <div>
              <div className="clearfix"></div>
                <div className="readmin-panel">
                  <div className="panel-body">
                    {/* <div class="panel_title mt-20"><h4>Today's Data</h4></div> */}
                    <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleFilter)}>
                      <div className="row mtm-20">
                          <div className="col-sm-6 insfield mt-35">
                              <Field
                                autoFocus={true}
                                name="domainName"
                                label="Domain Name"
                                handleNewRequest={this.handleDomainNameSelection}
                                options={this.props.patientSkillDomain}
                                component={renderAutoCompleteSingleSelect} 
                              />
                          </div>
                          <div className="col-sm-6 insfield mt-35">
                              <Field
                                name="programName"
                                label="Program Name"
                                handleNewRequest={this.handleProgramNameSelection}
                                options={this.props.patientSkillProgram}
                                component={renderAutoCompleteSingleSelect} 
                              />
                          </div>
                          <div className="col-sm-6 insfield mt-35">
                              <Field
                                name="targetName"
                                label="Target Name"
                                handleNewRequest={this.handleTargetNameSelection}
                                options={this.props.patientSkillTarget}
                                component={renderAutoCompleteSingleSelect} 
                              />
                          </div>
                          <div className="col-sm-6 insfield mt-35">
                              <Field                         
                                name="targetType"
                                label="Target Type"
                                handleNewRequest={this.handleTargetTypeSelection}
                                options={this.props.masterData}
                                component={renderAutoCompleteSingleSelect} 
                              />
                          </div>
                          <div className="col-sm-6 mt-12 pt-4">
                            {this.state.openNewProgram  && this.state.type === "DTT" &&
                              <CollectDTTData
                              // skillsAcquisitionTargetId={this.state.skillsAcquisitionTargetId}
                              // skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                              patientId={this.state.patientId}
                              collectedDataId={this.state.collectedDataId}
                              targetType={this.state.targetType}
                              autoFocus={true}
                              name="targetType"
                              label="Target Type"
                              closeDialog={() => this.handleClose()}
                              />
                            }
                          </div>
                          <div className="col-sm-6 mt-12 pt-4">
                            {this.state.openNewProgram  && this.state.type === "TASK ANALYSIS" &&
                              <CollectTAData
                              // skillsAcquisitionTargetId={this.state.skillsAcquisitionTargetId}
                              // skillsAcquisitionProgramId={this.state.skillsAcquisitionProgramId}
                              collectedDataId={this.state.collectedDataId}
                              patientId={this.state.patientId}
                              targetType={this.state.targetType}
                              autoFocus={true}
                              name="targetType"
                              label="Target Type"
                              closeDialog={() => this.handleClose()}
                              />
                            }
                          </div>
                      </div>
                      <div className="row">
                          <div className="col-8 col-sm-8 col-md-8 reset-btn claims_btn"></div>
                          <div className="col-4 col-sm-4 col-md-4 btn_rt reset-btn claims_filter">
                            <RaisedButton className="grey_btn" type="Submit" primary={true} >Filter</RaisedButton>
                            <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>                      
                        </div>
                       </div>
                    </form>
                  </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="table-responsive mt-15">
                    {patientSkillsAcqCollectedDataList && patientSkillsAcqCollectedDataList.length > 0 ?
                      <table className={tableClass}>
                        <thead>
                        <tr>
                            <th  width="5%"></th>   
                            <th width="20%">Domain Name</th>
                            <th width="12%">Program Name</th>
                            <th width="10%">Target Name</th>
                            <th width="12%">Target Type</th>
                            <th width="12%"> Response</th>
                            <th width="20%">{<Sorting noSort={!patientSkillsAcqCollectedDataList.length} setSortColumn={this.setSortColumn} columnName='sessionDate' displayName='Session Date' />}</th>
                            <th width="9%">Actions</th>                          
                          </tr>
                        </thead>
                        <tbody>
                          {this.renderData(patientSkillsAcqCollectedDataList)}
                        </tbody>
                      </table>
                      :
                      <table className={tableClass}>
                        <thead>
                        <tr>
                            <th width="5%"></th>
                            <th width="20%">Domain Name</th>
                            <th width="12%">Program Name</th>
                            <th width="10%">Target Name</th>
                            <th width="12%">Target Type</th>
                            <th width="12%">Response</th>
                            <th width="20%">{<Sorting noSort={!patientSkillsAcqCollectedDataList.length} setSortColumn={this.setSortColumn} columnName='sessionDate' displayName='Session Date' />}</th>
                            <th width="9%">Actions</th>                            
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td colSpan="8">
                              <div className="familydl text-center no-record">No record found!</div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    } 
                    {
                      PatientSkillAcqCollectedMeta && PatientSkillAcqCollectedMeta['totalPages']
                        ?
                        <PaginatorCustom data={PatientSkillAcqCollectedMeta} handlePageChange={(page_number) => this.handleFilter(page_number)} />
                        :
                        null
                    }
                  </div>
                </div>
              </div>
            </div>
         )
    }
}
          
          

function mapStateToProps(state) {
  // console.log("mapStateToProps",state.patientSkillAcqActiveTarget);
  // console.log("mapStateToProps",state.skillAcquisitionTarget);
  // console.log("patientSkillAcqActiveTarget",state.patientSkillAcqActiveTarget)


  return {
        isEventOccureSABCollactDataListByTargetId: state.skillAcquisitionTarget.isEventOccureSABCollactDataListByTargetId,
        collapseMenuId:state.patientSkillAcqActiveTarget.collapseMenuId,
        isEventOccurePatientSkillAcqCollectDataNewFlow: state.patientSkillAcqActiveTarget.isEventOccurePatientSkillAcqCollectDataNewFlow,
        isEventOccureSkillAcq:state.skillAcquisitionTarget.isEventOccureSkillAcq,
        loading: state.patientSkillAcqActiveTarget.loading,
        patientSkillDomain: state.patientSkillAcqActiveTarget.patientSkillDomain ? state.patientSkillAcqActiveTarget.patientSkillDomain.data : [],
        patientSkillProgram:state.patientSkillAcqActiveTarget.patientSkillProgram ? state.patientSkillAcqActiveTarget.patientSkillProgram.data : [],
        patientSkillTarget:state.patientSkillAcqActiveTarget.patientSkillTarget ? state. patientSkillAcqActiveTarget.patientSkillTarget.data : [],
        masterData:state.patientSkillAcqActiveTarget.masterData ? state. patientSkillAcqActiveTarget.masterData.targetType : [],
        patientSkillAcqCollectedDataList: state.patientSkillAcqActiveTarget.patientSkillAcqCollectData ?  state.patientSkillAcqActiveTarget.patientSkillAcqCollectData.data : [],
        patientSkillAcqCollectedMeta: state.patientSkillAcqActiveTarget.patientSkillAcqCollectData ?  state.patientSkillAcqActiveTarget.patientSkillAcqCollectData.meta : [],
        promptCodeListData: state.patient_prompt_code.promptCodeList !== null ? state.patient_prompt_code.promptCodeList : [],
      };
}
   
TodaysData = reduxForm({
  form: 'TodaysDataForm',
  enableReinitialize: true,
})(TodaysData);

export default connect(mapStateToProps, { setIsEventOccureSABCollactDataListByTargetIdFalse,setCollapseMenuId,setIsEventOccurePatientSkillAcqCollectDataNewFlowFalse,setIsEventOccureSkillAcqFalse,getMasterData,selectedProgramForPatientSkillAcqDomains, selectedProgramForPatientSkillAcqProgram, selectedProgramForPatientSkillAcqTarget,get_patientSkillAcqCollectDataNewFlow,deletePatientSkillAcqCollectedData, EnableTodayLabel, DesableTodayLabel, ResetList, updateSkillAcqCollectedTADataPromtCodeAction, updateSkillAcqCollectedDTTDataPromtCodeAction, updateCollectedSkillAquisitionBehaviorDataForTodaysData, deleteSkillAquisitionBehaviorCollactDataForTodaysData})(TodaysData)




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Maintenance/components/targets/TodaysData.js